module.exports = ".container{\r\n\twidth: 100%;\r\n\tmin-height: 100vh;\r\n\tbackground-color: rgb(240,240,240);\r\n\tborder-top: 20px solid transparent;\r\n}\r\n.main{\r\n\tmax-width: 1180px;\r\n\tmin-height: 100vh;\r\n\tbackground-color: white;\r\n\tmargin-left: auto;\r\n\tmargin-right: auto;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/contact/contact.component.css
// module id = ./src/app/components/contact/contact.component.css
// module chunks = main